module.exports = ".listado-caracteristicas {\n  min-width: 622px; }\n"